import TableRowCell from "./TableRowCell";
import { TableRowProps } from "./TableRowProps";

const TableRow = <T,>({ data, columns, enableRowSelection, isRowSelectable, onRowSelect, selectedRow, getRowKey }: TableRowProps<T>) => {
    return (
        <>
            {data.map((item, itemIndex) => (
                <tr key={getRowKey?.(item) ?? `table-body-${itemIndex}`}>
                    {columns.map((column, columnIndex) => (
                        <TableRowCell
                            key={`table-row-cell-${columnIndex}`}
                            item={item}
                            column={column}
                            columnIndex={columnIndex}
                            enableRowSelection={enableRowSelection}
                            isRowSelectable={isRowSelectable ? isRowSelectable(item) : true}
                            onRowSelect={onRowSelect}
                            isSelected={selectedRow === item}
                        />
                    ))}
                </tr>
            ))}
        </>
    );
};

export default TableRow;
